module.exports = __webpack_public_path__ + "media/images/icon_member01_on_20-20-96afdbf6fd077d4d80ddd13ca4637ce9.png";